import { Component, HostListener, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Contract } from "@edp-components/edp-contract/edp-contract.model";
import { SCREEN_SIZES } from "@edp-enums/screen-sizes.enum";
import { Menu } from "@edp-models/menu.model";
import { CloseSidebarAction } from "@edp-store/actions/layout.actions";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { getMainMenu, getShowSidebarSublevel } from "@edp-store/selectors/layout.selectors";
import { getUser, isUserEdpE } from "@edp-store/selectors/user.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { NgbNavChangeEvent } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { combineLatest, Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ShowContractSelection } from "@edp-store/actions/contract.actions";
import { OperationHistoryService } from "@edp-services/operation-history.service";
import { AppBannerService } from "@edp-services/app-banner.service";

@Component({
    selector: "edp-e-sidebar",
    templateUrl: "./edp-e-sidebar.component.html",
    styleUrls: ["./edp-e-sidebar.component.scss"],
})
export class EdpESidebarComponent implements OnInit {
    @Input() open: boolean;
    @Input() hideSubMenu: boolean;
    public contract: Contract = null;
    public homepage: string[];
    public openSidebarSublevel: boolean;
    public mainMenu$: Observable<Menu[]> = this.store.select(getMainMenu);
    public showAppBanner = false;

    private unsubscribe = new Subject();
    private timeout: ReturnType<typeof setTimeout>;

    @HostListener("window:resize")
    public onResize() {
        if (window.innerWidth > SCREEN_SIZES.LG) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.closeSidebar();
            }, 200);
        }
    }

    constructor(
        private router: Router,
        private store: Store<IAppState>,
        private operationHistoryService: OperationHistoryService,
        private readonly appBannerService: AppBannerService
    ) {
        this.showAppBanner = this.appBannerService.show();

        this.store.pipe(select(getShowSidebarSublevel)).subscribe(openSidebarSublevel => {
            this.openSidebarSublevel = openSidebarSublevel;
        });
    }

    public ngOnInit(): void {
        combineLatest([
            this.store.pipe(takeUntil(this.unsubscribe), select(getUser)),
            this.store.pipe(takeUntil(this.unsubscribe), select(getContract)),
        ]).subscribe(([user, contract]) => {
            if (contract && contract.ContractId !== this.contract?.ContractId) {
                this.contract = contract;
                this.homepage = [`/energia/${contract.ContractId}/inicio`];
            }
        });
    }

    public navigateTo = (item: Menu) => {
        if (item.grouping === "energy-e" && !this.contract) {
            this.store.dispatch(new ShowContractSelection());
        } else {
            if (item.callToAction) {
                item.callToAction();
            }
            this.router.navigate(item.routerPath).then(() => {
                if (this.open && item.submenu.length) {
                    this.openSidebarSublevel = true;
                } else {
                    this.closeSidebar();
                }
            });
        }

        if (item.operationHistory) {
            const contractId = this.contract ? this.contract.ContractId : null;
            this.operationHistoryService.registerWithContract(contractId, item.operationHistory);
        }
    };

    public closeSidebar(): void {
        if (open) {
            this.store.dispatch(new CloseSidebarAction());
        }
    }
}
